import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export default function Notifikasi() {
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const load = async () => { const { data } = await api.get("/notifikasi"); setItems(data.items); setUnread(data.unread); };
  useEffect(() => { load(); }, []);
  const markAll = async () => { await api.post("/notifikasi/read-all"); load(); };
  const markOne = async (id) => { await api.post(`/notifikasi/${id}/read`); load(); };
  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-widest text-slate-400">Sistem</div>
          <h1 className="font-display text-3xl font-bold text-[#064E3B]">Notifikasi ({unread} belum dibaca)</h1>
        </div>
        <button className="imsyaf-btn-outline" onClick={markAll} data-testid="notif-read-all">Tandai semua dibaca</button>
      </div>
      <div className="space-y-2">
        {items.length === 0 && <div className="imsyaf-card p-6 text-center text-slate-400">Belum ada notifikasi.</div>}
        {items.map((n) => (
          <button key={n.id} onClick={() => markOne(n.id)} className={`imsyaf-card p-4 w-full text-left flex items-start justify-between ${!n.read ? "border-l-4 border-l-[#166534]" : "opacity-70"}`}>
            <div>
              <div className="font-semibold text-[#064E3B]">{n.title}</div>
              <div className="text-sm text-slate-600">{n.body}</div>
              <div className="text-xs text-slate-400 mt-1">{n.created_at}</div>
            </div>
            <span className={`imsyaf-badge ${n.kind?.includes("pelanggaran") ? "bg-red-100 text-red-700" : "bg-green-100 text-green-800"}`}>{n.kind}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
